/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateOrderbookOptions,
  UpdateOrderbookStatus200,
  UpdateOrderbookStatus400,
  UpdateOrderbookStatus404,
  UpdateOrderbookStatus500,
} from '../types/UpdateOrderbook'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateOrderbook } from '../clients/updateOrderbook'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateOrderbookMutationKey = () => [{ url: '/v1/orderbooks/:order_book_id' }] as const

export function updateOrderbookMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateOrderbookMutationKey()
  return mutationOptions<
    UpdateOrderbookStatus200,
    ResponseErrorConfig<
      UpdateOrderbookStatus400 | UpdateOrderbookStatus404 | UpdateOrderbookStatus500
    >,
    UpdateOrderbookOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateOrderbook({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Update an existing orderbook
 * {@link /v1/orderbooks/:order_book_id}
 */
export function useUpdateOrderbook<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateOrderbookStatus200,
      ResponseErrorConfig<
        UpdateOrderbookStatus400 | UpdateOrderbookStatus404 | UpdateOrderbookStatus500
      >,
      UpdateOrderbookOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateOrderbookMutationKey()

  const baseOptions = updateOrderbookMutationOptions(config) as UseMutationOptions<
    UpdateOrderbookStatus200,
    ResponseErrorConfig<
      UpdateOrderbookStatus400 | UpdateOrderbookStatus404 | UpdateOrderbookStatus500
    >,
    UpdateOrderbookOptions,
    TContext
  >

  return useMutation<
    UpdateOrderbookStatus200,
    ResponseErrorConfig<
      UpdateOrderbookStatus400 | UpdateOrderbookStatus404 | UpdateOrderbookStatus500
    >,
    UpdateOrderbookOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateOrderbookStatus200,
    ResponseErrorConfig<
      UpdateOrderbookStatus400 | UpdateOrderbookStatus404 | UpdateOrderbookStatus500
    >,
    UpdateOrderbookOptions,
    TContext
  >
}
